import classNames from "classnames";
import React from "react";
import { Card } from "reactstrap";

export const DataTable = ({ className, bodyClassName, title, scrollable, ...props }) => {
  const cardClass = [
    "card-bordered",
    className || "",
    scrollable ? "data-table-scrollable" : "",
  ].filter(Boolean).join(" ");
  return (
    <Card className={cardClass}>
      <div className="card-inner-group">{props.children}</div>
    </Card>
  );
};

export const DataTableTitle = ({ ...props }) => {
  return (
    <div className="card-inner position-relative card-tools-toggle">
      <div className="card-title-group">{props.children}</div>
    </div>
  );
};

export const DataTableBody = ({ compact, className, bodyclass, ...props }) => {
  return (
    <div className={`card-inner p-0 ${className ? className : ""}`}>
      <div className={`nk-tb-list nk-tb-ulist ${bodyclass ? bodyclass : ""} ${compact ? "is-compact" : ""}`}>
        {props.children}
      </div>
    </div>
  );
};

export const DataTableHead = ({ ...props }) => {
  return <div className="nk-tb-item nk-tb-head">{props.children}</div>;
};

export const DataTableRow = ({ className, size, dataLabel, ...props }) => {
  const rowClass = classNames({
    "nk-tb-col": true,
    [`${className}`]: className,
    [`tb-col-${size}`]: size,
  });
  const divProps = {
    className: rowClass,
    onClick: (ev) => (props.onClick ? props.onClick(ev) : ""),
    ...(dataLabel != null && dataLabel !== "" ? { "data-label": dataLabel } : {}),
  };

  if (props.renderer)
    return <div {...divProps}>{props.renderer}</div>;

  return <div {...divProps}>{props.children}</div>;
};

export const DataTableItem = ({ className, ...props }) => {
  return <div
    className={`nk-tb-item ${className ? className : ""}`}
    onClick={(ev) => { return props.onClick ? props.onClick(ev) : ''; }}
  >{props.children}</div>;
};
